export default __webpack_public_path__ + "static/media/fastlane_detail10.a2d2e9ed.jpg";